const RELOAD_KEY = 'prairi.reloadedForNewVersion';

function errorText(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const value = error as { name?: unknown; message?: unknown };
    return `${String(value.name || '')} ${String(value.message || '')}`;
  }
  return '';
}

/** True when the open tab is asking for a script from a site version that is no longer deployed. */
export function isStaleAppFailure(error: unknown): boolean {
  const text = errorText(error);
  return (
    /ChunkLoadError|Loading chunk [\w.]+ failed/i.test(text) ||
    /dynamically imported module/i.test(text) ||
    /module script failed/i.test(text) ||
    /valid JavaScript MIME type/i.test(text) ||
    /Unexpected token/i.test(text)
  );
}

export function reloadStaleAppOnce(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === '1') return false;
    sessionStorage.setItem(RELOAD_KEY, '1');
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

/** Allow a later deploy to reload this tab once. A crash during boot leaves the flag set. */
export function markAppBooted(): void {
  window.setTimeout(() => {
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch {
      // Private mode can block storage. The tab then reloads at most once.
    }
  }, 15000);
}

function recover(error: unknown): void {
  if (isStaleAppFailure(error)) reloadStaleAppOnce();
}

export function installStaleAppRecovery(): void {
  window.addEventListener('unhandledrejection', event => {
    recover(event.reason);
  });
  window.addEventListener(
    'error',
    event => {
      const target = event.target;
      if (target instanceof HTMLScriptElement && target.src.includes('/static/')) {
        reloadStaleAppOnce();
        return;
      }
      recover(event.error || event.message);
    },
    true
  );
}
